module.exports = {"141025100":"岳阳镇","141025101":"北平镇","141025102":"古阳镇","141025103":"旧县镇","141025200":"石壁乡","141025201":"永乐乡","141025202":"南垣乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141025.json
// module id = 366
// module chunks = 0